import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect} from 'react';
import {connect, useDispatch} from 'react-redux';
import Config from '../../../Config';
import {Container} from 'reactstrap';
import lodash from 'lodash';
import {isMobile} from 'react-device-detect';
import {
  resetState,
  logoutOtp,
  mapUserPhoneNumber,
  setError,
  handleCurrentStep,
  setHeadlineText,
  getCustomerCellularList,
  setAccountDataWithNewSelectedPackage,
  saveSelectedDataForFixedPriceAccount,
  getSelectedSubscriberDetails,
  sendRequestChangingCellularPackage,
  changeHandler,
  saveToHistory,
  doCallBack,
  getCurrentCellularPricePlan,
  activateSelectPage,
  setPackagesList,
  setDiscountedPackagesList,
  setCheckBoxStatusForSelectedAccount,
  setAllCellularList,
  setWarningConfirmation,
  setCollaborationApproval,
  redirectToLogin,
  setSelectedForm,
  changeCallbackHandler,
  clearHistory,
  resetThirdParty,
  checkIfExistsInFather,
  validateAndSendMagicLink,
  IsCellcomNumber,
} from './changePricePlanSlice';
import {stepEnum, MagicLinkEnum} from './ChangePricePlanConsts';
import {resetAuth} from '../../../utilities/authentication/authenticationSlice';
import {resetOtpState} from '../../Shared/OtpAuthentication/otpAuthenticationSlice';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';
import SelectAccountComponent from './SelectAccount/SelectAccountComponent';
import WarningComponent from './WarningComponent';
import SelectingFlowComponent from './SelectNewPackage/SelectingFlowComponent';
import CompletedComponent from './Completed/CompletedComponent';
import ResponseContactForm from './SendingContract/ResponseContactForm';
import CallBackActionComponent from './CallBackActionComponent/CallBackActionComponent';
import OtpStepComponent from './OtpStepComponent';
import PopUp from '../../Shared/Popup/PopUp';
import CurrentPackagePopupContent from './Popups/CurrentPackagePopupContent';
import errors from './Errors/errors';
import useClearStateResetFlag from '../../../utilities/hooks/useClearStateResetFlag';
import {getOrganizationFamilyPackagesData} from '../WelcomeBlock/welcomeBlockSlice';
import {dwhOpenCurrentPackagePopup, dwhCloseCurrentPackagePopup, dwhThirdPartyConsentCheckboxDisplay} from './reports/dwhReports';
import SuccessOrErrorScreen from '../FamilyMemberCellularSaleBlock/OrganizationFamilyMembersSale/successOrErrorScreen/SuccessOrErrorScreen';
import {OptionPopUp} from '../FamilyMemberCellularSaleBlock/OrganizationFamilyMembersSale/optionPopUp/OptionPopUp';
import {GetOrganizationDataFromEpi} from '../FamilyMemberCellularSaleBlock/familyMemberCellularSaleSlice';
import {setOrganizationDataAction} from '../WelcomeBlock/welcomeBlockSlice';
import {handleCellularPackageBought} from '../SelfCareSuccessMsgBlock/SelfCareSuccessMsgBlockSlice';
import {getSubscriberDetails, setRetainSubscriberOnLoad} from '../../Page/SelfCarePage/SelfCareSlice';
import {removeHtmlTagsAndEntities} from 'app/utilities/StringHelpers/StringHelpers';
import {dwhDictionary, dwhReport} from '../IdfSaleBlock/dwhReports/dwhGeneralReport';
import BlockingDualNumberPage from 'app/Components/Shared/BlockingDualNumberPage/BlockingDualNumberPage';
import {ProcssType} from 'app/Components/Shared/BlockingDualNumberPage/constant';
import { getMarketCode } from 'app/utilities/domain/domainConstants';

const ChangePricePlanMain = (props) => {
  const dispatch = useDispatch();
  const [currentPackagePopup, openCurrentPackagePopup] = useState(false);
  const [activeAccount, setActiveAccount] = useState(null);
  const [currentPackageAccountNumber, setCurrentPackageAccountNumber] = useState('');
  const currentOfferId = props.data.selectedAccount?.pricePlan;
  const subscriber = props.userData.loginData?.userDetails.contactNumber;
  const magicLinkParams = props.userData.loginData?.magicLinkParameters;
  const pageURL = window.location.href;
  const customerName = `${props.userData.loginData?.userDetails?.firstName} ${props.userData.loginData?.userDetails?.lastName}`;
  const id = props.userData.loginData?.userDetails?.IDNumber;
  const newOfferID = props.data.selectedAccount?.newPackage?.offerID;
  const [mainTitle, setMainTitle] = useState('');
  const [secondaryTitle, setSecondaryTitle] = useState('');
  const [showThirdParty, setShowThirdParty] = useState(false);
  const marketCode = getMarketCode().toLowerCase();
  const gif = isMobile ? require(`./images/animation/mobileGif-${marketCode}.gif`) : require(`./images/animation/desktopGif-${marketCode}.gif`);

  useEffect(() => {
    if (props.data.isLoading) {
      props.showAppLoader();
    } else {
      props.hideAppLoader();
    }
  }, [props.data.isLoading]);

  useEffect(() => {
    if (props.data.magicLinkRes?.codeError) {
      sendFamilyMemberDwhReport(props.data.magicLinkRes.codeError);
    }
  }, [props.data.magicLinkRes]);
  useEffect(() => {
    if (props.data.error && props.data.errorReason === 'server_error') {
      props.handleCurrentStep({step: stepEnum.CALL_BACK, error: props.data.error});
    }
  }, [props.data.error]);

  useEffect(() => {
    if (props.data.completed) {
      props.handleCurrentStep({step: stepEnum.COMPLETED, error: props.data.error});
    }
  }, [props.data.completed]);

  useEffect(() => {
    if (props.data.activateTransitionAnimation) {
      props.handleCurrentStep({step: stepEnum.TRANSITION_ANIMATION, error: props.data.error});
    }
  }, [props.data.activateTransitionAnimation]);

  useEffect(() => {
    if (typeof window.scrollTo === 'function') {
      window.scrollTo(0, 0);
    }
    if (props.data.showSignCollaboration) {
      dwhThirdPartyConsentCheckboxDisplay(customerName, subscriber, id, 'מעבר תכנית');
    }
    return () => {
      props.resetState();
    };
  }, []);

  useEffect(() => {
    if (magicLinkParams) {
      props = {...props, orgId: magicLinkParams.orgNumber};
    }
  }, []);

  useEffect(() => {
    if (
      props.userData.loginData.isFullAuthenticated ||
      props.userData.loginData.isOtpExtendedAuthenticated ||
      props.userData.loginData.isOtpAuthenticated
    ) {
      props.mapUserPhoneNumber(props.userData.loginData.userDetails.contactNumber);
      if (props.data.allCellularPackagesForAccountData == null) {
        fetchData();
      }
    }
  }, [props.userData]);

  useEffect(() => {
    setTimeout(() => {
      if (props.userData.loginData && !props.data.currentStep) {
        handleCurrentStepOnLoading();
      }
    }, 1500);
  }, [props.userData.loginData]);

  useEffect(() => {
    if (props.userData.loginData) setShowThirdParty(shouldDisplayThirdParty());
  }, [props.organizationData, props.userData.loginData]);

  useEffect(() => {
    fetchMagicLinkData();
  }, [props.authenticationStore?.loginData?.magicLinkParameters?.orgNumber, props.welcomeBlock?.orgId]);

  useEffect(() => {
    if (props.data.getSelectedSubscriberDetailsCompleted) {
      if (props.userData.loginData.isFullAuthenticated || props.userData.loginData.isOtpExtendedAuthenticated) {
        if (props.data.selectedAccountExtendedData?.banlvl_pp_limited == 'Y' && !props.data.selectedAccountExtendedData?.upgradeAvailable) {
          const descriptionWithPhoneNumber = errors.fix_price_with_futurePP.description.replace(
            'phone_number',
            props.data.selectedAccount.subscriberNo,
          );
          const error_obj = {...errors.fix_price_with_futurePP, description: descriptionWithPhoneNumber};
          props.setError({text: error_obj, reason: 'fix_price_with_futurePP'});
          props.handleCurrentStep({step: stepEnum.CALL_BACK, error: true});
        } else if (props.data.selectedAccountExtendedData?.banlvl_pp_unlimited == 'Y' && !props.data.warningConfirmed) {
          props.handleCurrentStep({step: stepEnum.WARNING_ALERT, error: false});
        } else {
          props.handleCurrentStep({step: stepEnum.PACKAGE_SELECT, error: false});
        }
      } else {
        //OTP
        if (props.data.selectedAccountExtendedData?.banlvl_pp_limited == 'Y') {
          const descriptionWithPhoneNumber = errors.limitedOnOTP.description.replace(
            'phone_number',
            props.data.selectedAccount.subscriberNo,
          );
          const error_obj = {...errors.limitedOnOTP, description: descriptionWithPhoneNumber};
          props.setError({text: error_obj, reason: 'limitedOnOTP'});
        } else if (props.data.selectedAccountExtendedData?.banlvl_pp_unlimited == 'Y' && !props.data.warningConfirmed) {
          props.handleCurrentStep({step: stepEnum.WARNING_ALERT, error: false});
        } else {
          props.handleCurrentStep({step: stepEnum.PACKAGE_SELECT, error: false});
        }
      }
    }
  }, [props.data.getSelectedSubscriberDetailsCompleted]);

  async function fetchData() {
    await props.getCustomerCellularList();
  }

  function sendFamilyMemberDwhReport(codeError) {
    switch (codeError) {
      case MagicLinkEnum.LINK: {
        dwhReport(dwhDictionary.IDFFamilyMember_SelectionLine_Completed);
        break;
      }
      case MagicLinkEnum.MAXCAP: {
        dwhReport(dwhDictionary.IDFFamilyMember_GeneralError_Error_NoMoreBenefits);
        break;
      }
      case MagicLinkEnum.INVALIDFATHER: {
        dwhReport(dwhDictionary.IDFFamilyMember_GeneralError_Error_NotYourLine);
        break;
      }
      case MagicLinkEnum.MLERROR: {
        dwhReport(dwhDictionary.IDFFamilyMember_GeneralError_Error);
        break;
      }
      default: {
        break;
      }
    }
  }

  const fetchMagicLinkData = async () => {
    if (magicLinkParams) {
      const subscriberOrgId = magicLinkParams.orgNumber;
      if (subscriberOrgId !== undefined && subscriberOrgId !== null && subscriberOrgId !== '') {
        props.showAppLoader();
        await props.checkIfExistsInFather({subscriberNo: magicLinkParams.phoneNumber});
        var res = await props.GetOrganizationDataFromEpi(subscriberOrgId);
        props.setOrganizationDataAction(res.payload);
        await props.getOrganizationFamilyPackagesData();
        props.hideAppLoader();
      }
    }
  };

  const startOver = () => {
    const fetchedList = props.data.allCellularPackagesForAccountData;
    props.resetState();
    if (props.userData.loginData.isOtpAuthenticated) {
      props.resetAuth();
      props.resetOtpState();
      props.logoutOtp();
    } else {
      props.setAllCellularList(fetchedList);
      props.mapUserPhoneNumber(props.userData.loginData.userDetails.contactNumber);
      props.handleCurrentStep({step: stepEnum.SELECT_ACCOUNT, error: false});
    }
  };

  const shouldDisplayThirdParty = () => {
    if (
      (props.userData.loginData.isFullAuthenticated || props.userData.loginData.isOtpExtendedAuthenticated) &&
      props.orgId &&
      magicLinkParams == null &&
      props.organizationData?.canSendThirdPartyLink?.value
    ) {
      setMainTitle('איזה מנוי יצטרף לתוכנית?');
      setSecondaryTitle('');
      return true;
    }
    setMainTitle('שינוי חבילת סלולר');
    setSecondaryTitle('בחרו במנוי הרלוונטי');
    return false;
  };

  const callBackRequest = async () => {
    const sendObj = {
      id: props.userData.loginData.userDetails.IDNumber,
      phone: props.data.callBackPhone.phone,
      subject: props.iContent.callBackSubjectCode.value,
    };
    await props.doCallBack(sendObj);
  };

  const createRequestAndSend = async (agreeReceiveReceiptToMail) => {
    const sendingMethod = props.data.selectedForm == 'phone' ? 'S' : 'E';
    const otpPhoneNumber = props.userData.loginData.userDetails.contactNumber;
    const contactDestination = sendingMethod == 'S' ? props.data.form.phone.phone : props.data.form.email.email;
    const ban = props.data.selectedAccount.ban;
    const subscribersData = [];
    const collaborationApproval = props.data.collaborationApproval;
    if (props.data.selectedAccountExtendedData != null && props.data.selectedAccountExtendedData.banlvl_pp_limited == 'Y') {
      props.data.selectedAccountExtendedData.associatedSubscriberList.map((sub, index) => {
        const obj = {
          SubscriberNo: sub.subscriberNo,
          NewPricePlan: sub.newPackage.offerID,
          CurrentPricePlan: sub.pricePlan,
          PlanBlockId: sub.newPackage.blockID ?? '',
        };
        subscribersData.push(obj);
      });
    } else {
      const obj = {
        SubscriberNo: props.data.selectedAccount.subscriberNo,
        NewPricePlan: props.data.selectedAccount.newPackage.offerID,
        CurrentPricePlan: props.data.selectedAccount.pricePlan,
        PackageTitle: removeHtmlTagsAndEntities(props.data.selectedAccount.newPackage.title),
        TermsLink: props.data.selectedAccount.newPackage.termsLink ?? '',
        BillCycle: props.data.selectedAccount.billCycle ?? '',
        PlanBlockId: props.data.selectedAccount.newPackage.blockID ?? '',
      };
      subscribersData.push(obj);
    }
    const sendingObj = {
      sendingMethod: sendingMethod,
      contactDestination: contactDestination,
      otpPhoneNumber: otpPhoneNumber,
      ban: ban,
      subscribers: subscribersData,
      collaborationApproval: collaborationApproval,
      agreeReceiveReceiptToMail: agreeReceiveReceiptToMail,
      isImmediateTransitionPlan: props.data.selectedAccount.newPackage.isImmediateTransitionPlan,
    };
    await props.sendRequestChangingCellularPackage(sendingObj);
  };

  const showCurrentPackage = async (currentAccount, gaReport) => {
    let selectedForPackage = currentAccount || props.data.selectedAccount?.subscriberNo || magicLinkParams?.phoneNumber;
    let account = lodash.filter(props.data.allCellularPackagesForAccountData, function (account) {
      if (account.subscriberNo == selectedForPackage) {
        return account;
      }
    })?.[0];
    await props.getCurrentCellularPricePlan(account);
    if (gaReport) {
      //DWH
      let phoneNumber = currentAccount;
      dwhOpenCurrentPackagePopup({
        newOfferID,
        currentOfferId,
        subscriber,
        pageURL,
        customerName,
        id,
        phoneNumber,
      });
      setCurrentPackageAccountNumber(currentAccount);
    }
    openCurrentPackagePopup(true);
  };

  const handleCurrentStepOnLoading = () => {
    if (!props.data.error) {
      if (props.userData.loginData.isFullAuthenticated || props.userData.loginData.isOtpExtendedAuthenticated) {
        props.handleCurrentStep({step: stepEnum.SELECT_ACCOUNT, error: false, skipHistory: true});
      } else if (props.userData.loginData.isOtpAuthenticated) {
        props.handleCurrentStep({step: stepEnum.PACKAGE_SELECT, error: false, skipHistory: true});
      } else {
        props.handleCurrentStep({step: stepEnum.OTP, error: false, skipHistory: true});
      }
    }
  };

  const getCurrentStep = () => {
    //return <CompletedComponent props={props} startOver={startOver} backToPrivateArea={backToPrivateArea} />;

    switch (props.data.currentStep) {
      case stepEnum.SELECT_ACCOUNT:
        return (
          <SelectAccountComponent
            props={props}
            mainTitle={mainTitle}
            secondaryTitle={secondaryTitle}
            startOver={startOver}
            backToPrivateArea={backToPrivateArea}
            showCurrentPackage={showCurrentPackage}
            setActiveAccount={setActiveAccount}
            activeAccount={activeAccount}
            shouldDisplayThirdParty={showThirdParty}
          />
        );
      case stepEnum.OTP:
        return <OtpStepComponent props={props} />;
      case stepEnum.WARNING_ALERT:
        return <WarningComponent props={props} startOver={startOver} />;
      case stepEnum.PACKAGE_SELECT:
        return (
          <>
            <SelectAccountComponent
              props={props}
              mainTitle={mainTitle}
              secondaryTitle={secondaryTitle}
              startOver={startOver}
              backToPrivateArea={backToPrivateArea}
              showCurrentPackage={showCurrentPackage}
              setActiveAccount={setActiveAccount}
              activeAccount={activeAccount}
              shouldDisplayThirdParty={false}
            />
            <SelectingFlowComponent props={props} showCurrentPackage={showCurrentPackage} />
          </>
        );
      case stepEnum.CONTACT_FORM:
        return (
          <ResponseContactForm
            props={props}
            createRequestAndSend={createRequestAndSend}
            setCollaborationApproval={props.setCollaborationApproval}
          />
        );
      case stepEnum.COMPLETED:
        if (props?.data?.error) {
          return <CompletedComponent props={props} startOver={startOver} backToPrivateArea={backToPrivateArea} />;
        } else {
          props.handleCellularPackageBought({
            subscriberNo: props.data?.selectedAccount?.subscriberNo,
            fileUpload: props.data?.selectedAccount?.newPackage?.fileUpload,
            date: props.data?.selectedAccount?.billCycle,
            isImmediateTransitionPlan: props.data?.selectedAccount?.newPackage?.isImmediateTransitionPlan,
            isBenefitsForSoldiers: props.data?.selectedAccount?.newPackage?.isBenefitsForSoldiers,
            title: props.data?.selectedAccount?.newPackage?.title.trim().replace(/<[^>]+>/g, ''),
          });
          const handleSelectedSubscriber = async () => {
            await dispatch(setRetainSubscriberOnLoad(true));
            await dispatch(getSubscriberDetails(props?.data?.selectedAccount?.subscriberNo));
            props.context.navigateTo(props?.iContent?.linkForCellularSelfCare?.value?.url);
          };
          handleSelectedSubscriber();
        }
        break;
      case stepEnum.FINISHMAGICLINK:
        return (
          <SuccessOrErrorScreen
            popUpObj={{
              icon: props.data.magicLinkRes.icon,
              heading: props.data.magicLinkRes.resultMessage,
              secondaryHeading: props.data.magicLinkRes.message,
              phoneNumber: props.data.magicLinkRes.phoneNum,
              buttonText: 'סיום',
              btnClickedCallBack: () => startOver(),
            }}
          />
        );
      case stepEnum.FROM_MAGICKINK:
        return (
          <>
            <SelectAccountComponent
              props={props}
              mainTitle={mainTitle}
              secondaryTitle={secondaryTitle}
              startOver={startOver}
              backToPrivateArea={backToPrivateArea}
              showCurrentPackage={showCurrentPackage}
              setActiveAccount={setActiveAccount}
              activeAccount={activeAccount}
              magicLinkNum={magicLinkParams.phoneNumber}
              shouldDisplayThirdParty={false}
            />
            <SelectingFlowComponent props={props} showCurrentPackage={showCurrentPackage} />
          </>
        );
      case stepEnum.CALL_BACK:
        return (
          <CallBackActionComponent
            props={props}
            backToPrivateArea={backToPrivateArea}
            callBackRequest={callBackRequest}
            startOver={startOver}
          />
        );
      case stepEnum.TRANSITION_ANIMATION:
        return (
          <Container className='transition-animation'>
            <Image className='gif' src={gif} />
          </Container>
        );
      case stepEnum.BLOCKING_DUAL_NUMBER:
        return (
          <BlockingDualNumberPage
            subscriberNo={props.data?.stepData?.subscriberNo}
            processType={ProcssType.CHANGE_PLAN}
            onSubmit={() => {
              props.handleCurrentStep({step: stepEnum.SELECT_ACCOUNT, error: false});
            }}
          />
        );
    }
  };

  useClearStateResetFlag();

  const backToPrivateArea = async () => {
    props.showAppLoader();
    window.location.replace(Config.lobbyUrl);
  };

  const goToTransfer = async () => {
    props.showAppLoader();
    window.location.replace(Config.basePath + props.iContent.LinkToTransfer?.value);
  };

  const BtnSubmitClick = () => {
    if (props.data.magicLinkRes.CodeError == 'VALIDATION') return goToTransfer();
    else if (props.data.magicLinkRes.CodeError == 'GENERAL') return startOver();
    else return backToPrivateArea();
  };

  const closeModal = () => {
    //DWH
    if (currentPackageAccountNumber) {
      let phoneNumber = currentPackageAccountNumber;
      dwhCloseCurrentPackagePopup({
        newOfferID,
        currentOfferId,
        subscriber,
        pageURL,
        customerName,
        id,
        phoneNumber,
      });
      setCurrentPackageAccountNumber('');
    }
    openCurrentPackagePopup(false);
  };

  const closeThirdPartySend = () => {
    props.resetThirdParty();
  };

  return (
    <>
      {getCurrentStep()}
      {props.data?.showThirdPartyPopup && (
        <PopUp showPopUp={props.data?.showThirdPartyPopup} onClose={() => closeThirdPartySend()}>
          <OptionPopUp
            popUpObj={{
              icon: props.data.magicLinkRes.icon,
              heading: props.data?.magicLinkRes?.resultMessage,
              secondaryHeading: props.data?.magicLinkRes?.message,
              phoneNumber: props.data?.magicLinkRes?.phoneNum,
              buttonText: props.data?.magicLinkRes?.extra,
              onBtnClick: () => {
                BtnSubmitClick();
              },
              footerText: props.data?.magicLinkRes?.footerText,
              footerTextClicked: () => {
                startOver();
              },
            }}
          />
        </PopUp>
      )}
      <PopUp showPopUp={currentPackagePopup} onClose={() => closeModal()}>
        <CurrentPackagePopupContent package={props.data.currentCellularPlan} />
      </PopUp>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    data: state.changePricePlan,
    userData: state.authentication,
    organizationData: state.selfcarePage?.organizationState,
    isStateReset: state.stateHistory.isStateReset,
    activePlan: state.activePlan,
    orgId: state.selfcarePage?.orgId,
    cellularPackageList: state.selfcarePage?.organizationState?.cellularPackageList,
    firstName: state.authentication?.loginData?.userDetails?.firstName,
    welcomeStore: state.welcomeBlock,
  };
};

const mapDispatchToProps = {
  resetState,
  logoutOtp,
  resetAuth,
  resetOtpState,
  mapUserPhoneNumber,
  setError,
  handleCurrentStep,
  setHeadlineText,
  saveToHistory,
  getCustomerCellularList,
  setAccountDataWithNewSelectedPackage,
  saveSelectedDataForFixedPriceAccount,
  getSelectedSubscriberDetails,
  sendRequestChangingCellularPackage,
  doCallBack,
  getCurrentCellularPricePlan,
  activateSelectPage,
  setPackagesList,
  setDiscountedPackagesList,
  setCheckBoxStatusForSelectedAccount,
  changeHandler,
  changeCallbackHandler,
  showAppLoader,
  hideAppLoader,
  setAllCellularList,
  setWarningConfirmation,
  setCollaborationApproval,
  redirectToLogin,
  setSelectedForm,
  clearHistory,
  resetThirdParty,
  validateAndSendMagicLink,
  checkIfExistsInFather,
  GetOrganizationDataFromEpi,
  setOrganizationDataAction,
  IsCellcomNumber,
  getOrganizationFamilyPackagesData,
  handleCellularPackageBought,
  getSubscriberDetails,
  setRetainSubscriberOnLoad,
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangePricePlanMain);
